// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__FoRYz","banner_title":"banner_banner_title__4iLcG"};